import {
  MICROSOFT_ENQUIRY_SUBMITTED,
  PAGE_VIEW,
  type BookingConversionIntent,
} from './events'
import { isBrowserAdvertisingMeasurementGranted } from '@/lib/consent/advertising-consent'

type MicrosoftUetWindow = Window & {
  uetq?: { push: (event: 'event', action: string, parameters: Record<string, string>) => unknown }
}

/**
 * Load UET only after optional cookies are allowed. The consent command must
 * precede construction and pageLoad so Microsoft receives `asc=granted` on
 * every event instead of reporting a missing consent signal.
 */
export function microsoftUetBootstrapScript(tagId: string): string {
  const serializedTagId = JSON.stringify(tagId)
  return `!function(w,d,t,r,u){var f,n,i;w[u]=w[u]||[],w[u].push("consent","default",{ad_storage:"granted"}),f=function(){var o={ti:${serializedTagId},enableAutoSpaTracking:false};o.q=w[u],w[u]=new UET(o),w[u].push("pageLoad")},n=d.createElement(t),n.src=r,n.async=1,n.onload=n.onreadystatechange=function(){var s=this.readyState;s&&s!=="loaded"&&s!=="complete"||(f(),n.onload=n.onreadystatechange=null)},i=d.getElementsByTagName(t)[0],i.parentNode.insertBefore(n,i)}(window,document,"script","https://bat.bing.com/bat.js","uetq");`
}

function pushMicrosoftEvent(action: string, parameters: Record<string, string>): void {
  if (!isBrowserAdvertisingMeasurementGranted()) return
  const queue = (window as MicrosoftUetWindow).uetq
  if (!queue || typeof queue.push !== 'function') return
  try {
    queue.push('event', action, parameters)
  } catch {
    // Analytics is best-effort and must never interrupt a completed enquiry.
  }
}

/** Record an accepted enquiry. No customer PII is sent to Microsoft. */
export function trackMicrosoftEnquiry(input: {
  referenceCode: string
  intent: BookingConversionIntent
}): void {
  pushMicrosoftEvent(
    MICROSOFT_ENQUIRY_SUBMITTED,
    {
      event_category: 'booking',
      event_label: input.intent,
      event_id: input.referenceCode,
    },
  )
}

/** Record a client-side App Router navigation after the initial page load. */
export function trackMicrosoftPageView(pagePath: string): void {
  pushMicrosoftEvent(PAGE_VIEW, { page_path: pagePath })
}
